import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import pimg from "../../assets/parinday/plus.webp";
import AcInImg from "../../assets/dhruvtara/ac_in.webp";

export default function Plus() {
  const [ref0, inView0] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <section className="text-center lg:text-left py-10 lg:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="relative z-[1] block bg-[hsla(0,0%,100%,0.55)] backdrop-blur-[30px] shadow-lg rounded-xl p-6 md:p-10">
            <img
              src={AcInImg}
              alt="session & collaborations"
              className="w-full max-w-md mx-auto mb-6"
            />
            <div
              ref={ref0}
              className="text-sm lg:text-base text-neutral-600 space-y-4"
            >
              {[
                {
                  title: "Cancer awareness walkathon, Vasant Vihar",
                  count: 200,
                },
                {
                  title: "Gynaecologist Session, Vivekananda school",
                  count: 70,
                },
                { title: "Movie Screening, Rotaract Club", count: 100 },
                { title: "Pad distribution Drive, Kusumpur Pahari", count: 70 },
                {
                  title: "Demystifying period for boys, Andhra school",
                  count: 90,
                },
                {
                  title: "Breast Cancer awareness, Indian Cancer society",
                  count: 80,
                },
                {
                  title: "Menstrual awareness & pad dist. drive, Nawada",
                  count: 50,
                },
              ].map(({ title, count }, idx) => (
                <div key={idx} className="flex justify-between flex-wrap">
                  <span className="mr-2">{title}:</span>
                  <strong>
                    {inView0 && <CountUp end={count} duration={2} />}+
                    Beneficiaries
                  </strong>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 text-center">
              <div>
                <div ref={ref1} className="text-3xl font-bold text-[#FBABAD]">
                  {inView1 && <CountUp end={7} duration={2} />}+
                </div>
                <h5 className="text-lg font-semibold text-[#921D3F]">
                  Ventures
                </h5>
              </div>

              <div>
                <div ref={ref2} className="text-3xl font-bold text-[#FBABAD]">
                  {inView2 && <CountUp end={800} duration={2} />}+
                </div>
                <h5 className="text-lg font-semibold text-[#921D3F]">
                  Beneficiaries Served
                </h5>
              </div>
              <div>
                <div ref={ref3} className="text-3xl font-bold text-[#FBABAD]">
                  Jan {inView3 && <CountUp end={22} duration={2} />}
                </div>
                <h5 className="text-lg font-semibold text-[#921D3F]">
                  Launched
                </h5>
              </div>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <img
              src={pimg}
              alt="illustration"
              className="w-full max-w-sm lg:max-w-lg shadow-lg hidden lg:block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
